import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'utils/types';

import { selectors as authSelectors } from 'state/auth';
import {
  actions as ordersActions,
  selectors as ordersSelectors,
} from 'state/orders';

import Filters from 'components/orders/Filters/component';

const enhance = compose(
  withTranslation('Orders'),
  connect(
    (state) => ({
      users: authSelectors.getUsersInShipper(state),
      user: ordersSelectors.getFilterUser(state),
      isFetching: ordersSelectors.isFetching(state),
      numberOfOrders: ordersSelectors.getCount(state),
      pathname: state.router.location.pathname,
    }),
    {
      setUserFilter: ordersActions.setUserFilter,
      clearUserFilter: ordersActions.clearUserFilter,
    }
  ),
  withHandlers({
    setUserFilter:
      ({ setUserFilter, clearUserFilter, type }) =>
      (user) => {
        if (isEmpty(user) || user.value === false) {
          clearUserFilter({ pathname: type });
        } else {
          setUserFilter({ user, pathname: type });
        }
      },
  })
);

export default enhance(Filters);
